import React, { useState } from "react"
import { ButtonParts } from "~/components/atoms/ButtonParts"
import { useRouter } from "next/router"
import { Modal } from "react-bootstrap"
import { useDispatch } from "react-redux"

/*
    ヘルプボタンの生成用コンポーネント
    props
        onClick:クリックイベント
 */

interface Props {
  title?: string,
  explain?: string,
  size?: "L" | "M" | "S",
  category?: string,
}

export function HelpButton(props: Props) {
  const { explain, title, size = "M", category } = props
  const dispatch = useDispatch()
  const [show, showSate] = useState<boolean>(false)
  // const [isActive, modalState] = useState(false)const [show, showSate] = useState<boolean>(false)
  const router = useRouter()
  const page = router.query

  const modalChange = () => {
    showSate(true)
  }

  const onHide = (isNextPage: boolean = false) => {
    showSate(false)
  }
  return (
    <>
      <ButtonParts className={"btn btn-sm ml-1 help-icon"} action={modalChange} />

      <Modal className={"introduction-support-modal"} show={show} onHide={onHide}>
        <Modal.Header>
          <div className={"modal-title"}>{category}</div>
        </Modal.Header>
        <Modal.Body>
          <h5>{title}</h5>
          <p>{explain}</p>
        </Modal.Body>
        <Modal.Footer>
          <ButtonParts className={"btn btn-success"} action={onHide}>閉じる</ButtonParts>
        </Modal.Footer>
      </Modal>
    </>
  )
}